let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1pGC4")).then(() => parcelRequire('ifqTJ'));